import * as mapService from './mapService';
import getPanoramaData_ from './getPanoramaData';
import getMapLocations_ from './getMapLocations';

export const getPanoramaData = getPanoramaData_;
export const getMapLocations = getMapLocations_;

export const {
  getAddressByLocation,
  getElevation,
  getElevator,
  getGeocoder,
  getStreetViewService,
  getMap,
  getPanoramaByCoordinate,
  getRasterManager,
  initializeServices,
} = mapService;

export default mapService.default;
